import { ButtonStyle, ModalActionTypes } from '@acorns/web-components'

import trackEvent from 'utils/analytics/trackEvent'
import { getFlow } from 'utils/FlowProvider/utils'
import { PromptConfig } from 'utils/prompts'

interface Strings {
  title: string
  description: string
  primaryLabel: string
  secondaryLabel: string
}

interface VerifyEmailInput {
  handleChange: () => void
  handleOk: () => void
  strings: Strings
  partner: object
}

export const VerifyEmailModal = ({
  handleChange,
  handleOk,
  strings,
  partner,
}: VerifyEmailInput): PromptConfig => {
  const handlePrimaryCTAClick = () => {
    trackEvent('Button Tapped', {
      eventData: {
        object_name: 'createAccountVerifyEmailModalVerifyCTA',
        screen: 'createAccountVerifyEmailModalVerifyCTA',
        screen_name: 'createAccountVerifyEmailModalVerifyCTA',
        feature: 'createAccountVerifyEmailModalVerifyCTA',
        event_description: 'Button Tapped',
        object: 'Button',
        action: 'Tapped',
      },
      flow: getFlow(),
      partner,
    })
    handleOk()
  }
  trackEvent('Screen Viewed', {
    eventData: {
      feature: 'Create Account Verify Email Modal',
      object_name: 'createAccountVerifyEmailModal',
      screen: 'createAccountVerifyEmailScreenModal',
      screen_name: 'createAccountVerifyEmailModal',
      event_description: 'Screen Viewed',
      object: 'Screen',
      action: 'Viewed',
    },
    flow: getFlow(),
    partner,
  })
  return {
    actions: [
      {
        type: ModalActionTypes.secondary,
        label: strings.secondaryLabel,
        handler: handleChange,
      },
      {
        type: ModalActionTypes.primary,
        label: strings.primaryLabel,
        handler: handlePrimaryCTAClick,
      },
    ],
    buttonStyle: ButtonStyle.row,
    image: null,
    title: strings.title,
    message: strings.description,
    closeModalCallback: handleChange,
  }
}
